import styled from 'styled-components'

export const TabContainer = styled.div<{ $showFade?: boolean }>`
  display: flex;
  flex-direction: row;
  ${(props) => props.theme.container};
  padding: 4px;
  overflow-x: auto;
  scrollbar-width: none;
  transition: mask-image 0.25s ease, -webkit-mask-image 0.25s ease;

  -webkit-mask-image: ${(props) =>
    props.$showFade
      ? 'linear-gradient(to right, black calc(100% - 4rem), transparent 100%)'
      : 'none'};
  mask-image: ${(props) =>
    props.$showFade
      ? 'linear-gradient(to right, black calc(100% - 4rem), transparent 100%)'
      : 'none'};

  &::-webkit-scrollbar {
    display: none;
  }
`

export const Tab = styled.div<{ active: boolean; textContent: string; fullWidth?: boolean }>`
  position: relative;
  ${(props) => (props.fullWidth ? 'flex: 1 1 0; min-width: 0;' : 'flex-shrink: 0;')}
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 12px;
  background-color: ${(props) =>
    props.active ? props.theme.colorOrange : props.theme.transparent};
  color: transparent;

  ::after {
    content: '${(props) => props.textContent}';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    font-weight: ${(props) => (props.active ? '500' : '400')};
    color: ${(props) =>
      props.active ? props.theme.colorTextOnBrandBlack : props.theme.inactiveTabColor};
  }
`

export const SecondaryTab = styled.div<{ active: boolean; textContent: string }>`
  position: relative;
  width: 100%;
  cursor: pointer;
  padding: 10px 12px;
  background-color: ${(props) =>
    props.active ? `${props.theme.colorOrange}30` : props.theme.transparent};
  color: ${(props) => (props.active ? props.theme.colorOrange : props.theme.greyText)};
  border-bottom: ${(props) =>
    props.active ? `1px solid ${props.theme.colorOrange}` : '1px solid #6A6A6A'};
  text-align: center;

  &:first-child {
    border-top-left-radius: 12px;
  }
  &:last-child {
    border-top-right-radius: 12px;
  }
`

export const SectionTabContainer = styled.div`
  display: flex;
  flex-direction: row;
`
